(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["MIOCore"] = factory();
	else
		root["MIOCore"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./sources/MIOCore.ts":
/*!****************************!*\
  !*** ./sources/MIOCore.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOCoreAddLanguage: () => (/* binding */ MIOCoreAddLanguage),
/* harmony export */   MIOCoreClassByName: () => (/* binding */ MIOCoreClassByName),
/* harmony export */   MIOCoreGetContentsFromURLString: () => (/* binding */ MIOCoreGetContentsFromURLString),
/* harmony export */   MIOCoreGetDeviceUUID: () => (/* binding */ MIOCoreGetDeviceUUID),
/* harmony export */   MIOCoreGetLanguages: () => (/* binding */ MIOCoreGetLanguages),
/* harmony export */   MIOCoreGetMainURLString: () => (/* binding */ MIOCoreGetMainURLString),
/* harmony export */   MIOCoreGetPlatform: () => (/* binding */ MIOCoreGetPlatform),
/* harmony export */   MIOCoreGetPlatformLanguage: () => (/* binding */ MIOCoreGetPlatformLanguage),
/* harmony export */   MIOCoreGetQueryOptions: () => (/* binding */ MIOCoreGetQueryOptions),
/* harmony export */   MIOCoreIsDesktop: () => (/* binding */ MIOCoreIsDesktop),
/* harmony export */   MIOCoreIsMobile: () => (/* binding */ MIOCoreIsMobile),
/* harmony export */   MIOCoreIsPad: () => (/* binding */ MIOCoreIsPad),
/* harmony export */   MIOCoreIsPhone: () => (/* binding */ MIOCoreIsPhone),
/* harmony export */   MIOCorePlatformType: () => (/* binding */ MIOCorePlatformType),
/* harmony export */   MIOCoreRegisterClassByName: () => (/* binding */ MIOCoreRegisterClassByName)
/* harmony export */ });
/* harmony import */ var _MIOCoreUUID__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./MIOCoreUUID */ "./sources/MIOCoreUUID.ts");

var _miocore_languages = null;
function MIOCoreAddLanguage(lang, url) {
    if (_miocore_languages == null)
        _miocore_languages = {};
    _miocore_languages[lang] = url;
}
function MIOCoreGetLanguages() {
    return _miocore_languages;
}
var _miocore_device_uuid = (0,_MIOCoreUUID__WEBPACK_IMPORTED_MODULE_0__.MIOCoreUUIDcreate)();
function MIOCoreGetDeviceUUID() {
    return _miocore_device_uuid;
}
globalThis._micore_classes_by_name = {};
function MIOCoreRegisterClassByName(name, object) {
    globalThis._micore_classes_by_name[name] = object;
}
function MIOCoreClassByName(name) {
    var object_class = window[name];
    if (object_class == null)
        object_class = globalThis._micore_classes_by_name[name];
    return object_class;
}
var MIOCorePlatformType;
(function (MIOCorePlatformType) {
    MIOCorePlatformType[MIOCorePlatformType["Unknown"] = 0] = "Unknown";
    MIOCorePlatformType[MIOCorePlatformType["Chrome"] = 1] = "Chrome";
    MIOCorePlatformType[MIOCorePlatformType["Safari"] = 2] = "Safari";
})(MIOCorePlatformType || (MIOCorePlatformType = {}));
function MIOCoreGetPlatform() {
    var agent = navigator.userAgent.toLowerCase();
    var browserType = MIOCorePlatformType.Unknown;
    if (agent.indexOf("chrome") != -1)
        browserType = MIOCorePlatformType.Chrome;
    else if (agent.indexOf("safari") != -1)
        browserType = MIOCorePlatformType.Safari;
    return browserType;
}
function MIOCoreGetPlatformLocale() {
    // navigator.languages:    Chrome & FF
    // navigator.language:     Safari & Others
    // navigator.userLanguage: IE & Others
    return navigator.languages || navigator.language || navigator['userLanguage'];
}
function MIOCoreGetPlatformLanguage() {
    var locale = MIOCoreGetPlatformLocale();
    if (typeof (locale) == "string")
        return locale.substring(0, 2);
    else {
        var l = locale[0];
        return l.substring(0, 2);
    }
}
function MIOCoreIsDesktop() {
    return !MIOCoreIsMobile();
}
function MIOCoreIsPhone() {
    var phone = ['iphone', 'android', 'blackberry', 'nokia', 'opera mini', 'windows mobile', 'windows phone', 'iemobile'];
    for (var index = 0; index < phone.length; index++) {
        if (navigator.userAgent.toLowerCase().indexOf(phone[index].toLowerCase()) > 0) {
            return true;
        }
    }
    return false;
}
function MIOCoreIsPad() {
    var pad = ['ipad'];
    for (var index = 0; index < pad.length; index++) {
        if (navigator.userAgent.toLowerCase().indexOf(pad[index].toLowerCase()) > 0) {
            return true;
        }
    }
    return false;
}
function MIOCoreIsMobile() {
    //var mobile = ['iphone','ipad','android','blackberry','nokia','opera mini','windows mobile','windows phone','iemobile'];
    var mobile = ['iphone', 'android', 'blackberry', 'nokia', 'opera mini', 'windows mobile', 'windows phone', 'iemobile'];
    for (var index = 0; index < mobile.length; index++) {
        if (navigator.userAgent.toLowerCase().indexOf(mobile[index].toLowerCase()) > 0)
            return true;
    }
    // nothing found.. assume desktop
    return false;
}
function MIOCoreGetMainURLString() {
    return window.location.href;
}
function MIOCoreGetContentsFromURLString(path, target, completion) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        completion.call(target, this.status, this.responseText);
    };
    xhr.open("GET", path);
    xhr.send();
}
function MIOCoreGetQueryOptions() {
    var searchString = window.location.search;
    if (searchString.length == 0)
        return [];
    if (searchString.length > 0 && searchString[0] == "?")
        searchString = searchString.substr(1);
    var params = searchString.split("&");
    return params;
}


/***/ }),

/***/ "./sources/MIOCoreClone.ts":
/*!*********************************!*\
  !*** ./sources/MIOCoreClone.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOCoreArrayClone: () => (/* binding */ MIOCoreArrayClone),
/* harmony export */   MIOCoreObjectClone: () => (/* binding */ MIOCoreObjectClone)
/* harmony export */ });
function MIOCoreArrayClone(array) {
    var new_array = [];
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var v = array_1[_i];
        if (v instanceof Array)
            new_array.push(MIOCoreArrayClone(v));
        else if (v instanceof Object)
            new_array.push(MIOCoreObjectClone(v));
        else
            new_array.push(v);
    }
    return new_array;
}
function MIOCoreObjectClone(obj) {
    var new_obj = {};
    for (var key in obj) {
        var v = obj[key];
        if (v instanceof Array)
            new_obj[key] = MIOCoreArrayClone(v);
        else if (v instanceof Object)
            new_obj[key] = MIOCoreObjectClone(v);
        else
            new_obj[key] = v;
    }
    return new_obj;
}


/***/ }),

/***/ "./sources/MIOCoreDate.ts":
/*!********************************!*\
  !*** ./sources/MIOCoreDate.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MCDateAddDaysToDateString: () => (/* binding */ MCDateAddDaysToDateString),
/* harmony export */   MCDateCopy: () => (/* binding */ MCDateCopy),
/* harmony export */   MCDateFromMiliseconds: () => (/* binding */ MCDateFromMiliseconds),
/* harmony export */   MCDateGetDateString: () => (/* binding */ MCDateGetDateString),
/* harmony export */   MCDateGetDayFromDate: () => (/* binding */ MCDateGetDayFromDate),
/* harmony export */   MCDateGetDayStringFromDate: () => (/* binding */ MCDateGetDayStringFromDate),
/* harmony export */   MCDateGetFirstDateOfTheMonth: () => (/* binding */ MCDateGetFirstDateOfTheMonth),
/* harmony export */   MCDateGetFirstDayOfTheMonth: () => (/* binding */ MCDateGetFirstDayOfTheMonth),
/* harmony export */   MCDateGetFirstDayOfTheWeek: () => (/* binding */ MCDateGetFirstDayOfTheWeek),
/* harmony export */   MCDateGetLastDateOfTheMonth: () => (/* binding */ MCDateGetLastDateOfTheMonth),
/* harmony export */   MCDateGetLastDayOfTheMonth: () => (/* binding */ MCDateGetLastDayOfTheMonth),
/* harmony export */   MCDateGetLastDayOfTheWeek: () => (/* binding */ MCDateGetLastDayOfTheWeek),
/* harmony export */   MCDateGetMonthFromDate: () => (/* binding */ MCDateGetMonthFromDate),
/* harmony export */   MCDateGetString: () => (/* binding */ MCDateGetString),
/* harmony export */   MCDateGetStringForDay: () => (/* binding */ MCDateGetStringForDay),
/* harmony export */   MCDateGetStringForMonth: () => (/* binding */ MCDateGetStringForMonth),
/* harmony export */   MCDateGetTimeString: () => (/* binding */ MCDateGetTimeString),
/* harmony export */   MCDateGetUTCDateString: () => (/* binding */ MCDateGetUTCDateString),
/* harmony export */   MCDateGetUTCString: () => (/* binding */ MCDateGetUTCString),
/* harmony export */   MCDateGetUTCTimeString: () => (/* binding */ MCDateGetUTCTimeString),
/* harmony export */   MCDateGetYearFromDate: () => (/* binding */ MCDateGetYearFromDate),
/* harmony export */   MCDateNow: () => (/* binding */ MCDateNow),
/* harmony export */   MCDateRemoveDaysToDateString: () => (/* binding */ MCDateRemoveDaysToDateString),
/* harmony export */   MCDateSetFirstWeekDay: () => (/* binding */ MCDateSetFirstWeekDay),
/* harmony export */   MCDateToUTC: () => (/* binding */ MCDateToUTC),
/* harmony export */   MCDateToday: () => (/* binding */ MCDateToday),
/* harmony export */   MCDateTodayString: () => (/* binding */ MCDateTodayString),
/* harmony export */   MCDateTomorrow: () => (/* binding */ MCDateTomorrow),
/* harmony export */   MCDateYesterday: () => (/* binding */ MCDateYesterday),
/* harmony export */   NSDateFromString: () => (/* binding */ NSDateFromString),
/* harmony export */   isDate: () => (/* binding */ isDate)
/* harmony export */ });
/* harmony import */ var _MIOCoreLexer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./MIOCoreLexer */ "./sources/MIOCoreLexer.ts");
/**
 * Created by godshadow on 11/3/16.
 */

var NSDateFirstWeekDay;
(function (NSDateFirstWeekDay) {
    NSDateFirstWeekDay[NSDateFirstWeekDay["Sunday"] = 0] = "Sunday";
    NSDateFirstWeekDay[NSDateFirstWeekDay["Monday"] = 1] = "Monday";
})(NSDateFirstWeekDay || (NSDateFirstWeekDay = {}));
var _MCDateFirstWeekDay = NSDateFirstWeekDay.Monday;
var _MCDateStringDays = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
var _MCDateStringMonths = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
function MCDateSetFirstWeekDay(day) {
    _MCDateFirstWeekDay = day;
    if (day == NSDateFirstWeekDay.Sunday)
        _MCDateStringDays = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
    else
        _MCDateStringDays = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
}
function MCDateGetStringForMonth(month) {
    return _MCDateStringMonths[month];
}
function MCDateGetStringForDay(day) {
    return _MCDateStringDays[day];
}
function MCDateGetDayFromDate(date) {
    if (_MCDateFirstWeekDay == NSDateFirstWeekDay.Sunday)
        return date.getDay();
    // Transform to start on Monday instead of Sunday
    // 0 - Mon, 1 - Tue, 2 - Wed, 3 - Thu, 4 - Fri, 5 - Sat, 6 - Sun
    var day = date.getDay();
    if (day == 0)
        day = 6;
    else
        day--;
    return day;
}
function MCDateGetMonthFromDate(date) {
    return date.getMonth();
}
function MCDateGetYearFromDate(date) {
    return date.getFullYear();
}
function MCDateGetDayStringFromDate(date) {
    var day = MCDateGetDayFromDate(date);
    return MCDateGetStringForDay(day);
}
function MCDateGetString(date) {
    var d = MCDateGetDateString(date);
    var t = MCDateGetTimeString(date);
    return d + " " + t;
}
function MCDateGetDateString(date) {
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString(); // getMonth() is zero-based
    var dd = date.getDate().toString();
    return yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]); // padding
}
function MCDateGetTimeString(date) {
    var hh = date.getHours().toString();
    var mm = date.getMinutes().toString();
    return (hh[1] ? hh : "0" + hh[0]) + ":" + (mm[1] ? mm : "0" + mm[0]);
}
function MCDateGetUTCString(date) {
    var d = MCDateGetUTCDateString(date);
    var t = MCDateGetUTCTimeString(date);
    return d + " " + t;
}
function MCDateGetUTCDateString(date) {
    var yyyy = date.getUTCFullYear().toString();
    var mm = (date.getUTCMonth() + 1).toString(); // getMonth() is zero-based
    var dd = date.getUTCDate().toString();
    return yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]); // padding
}
function MCDateGetUTCTimeString(date) {
    var hh = date.getUTCHours().toString();
    var mm = date.getUTCMinutes().toString();
    var ss = date.getUTCSeconds().toString();
    return (hh[1] ? hh : "0" + hh[0]) + ":" + (mm[1] ? mm : "0" + mm[0]) + ":" + (ss[1] ? ss : "0" + ss[0]);
}
function NSDateFromString(string) {
    var lexer = new _MIOCoreLexer__WEBPACK_IMPORTED_MODULE_0__.MIOCoreLexer(string);
    // Values    
    // lexer.addTokenType(0, /^([0-9]{2,4})-/i); // Year
    // lexer.addTokenType(1, /^[0-9]{1,2}-/i); // Month
    // lexer.addTokenType(2, /^[0-9]{1,2} /i); // day
    // lexer.addTokenType(3, /^[0-9]{1,2}:/i); // hh // mm
    // lexer.addTokenType(4, /^[0-9]{1,2}/i); // ss
    lexer.addTokenType(0, /^([0-9]{2,4})-([0-9]{1,2})-([0-9]{1,2}) ([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})/i); // yyyy-MM-dd hh:mm:ss
    lexer.addTokenType(1, /^([0-9]{2,4})-([0-9]{1,2})-([0-9]{1,2}) ([0-9]{1,2}):([0-9]{1,2})/i); // yyyy-MM-dd hh:mm 
    lexer.addTokenType(2, /^([0-9]{2,4})-([0-9]{1,2})-([0-9]{1,2})/i); // yyyy-MM-dd    
    lexer.tokenize();
    var y = -1;
    var m = -1;
    var d = -1;
    var h = -1;
    var mm = -1;
    var s = -1;
    var token = lexer.nextToken();
    while (token != null) {
        switch (token.type) {
            case 0:
                y = token.matches[1];
                m = token.matches[2] - 1; // Month start by index 0
                d = token.matches[3];
                h = token.matches[4];
                mm = token.matches[5];
                s = token.matches[6];
                break;
            case 1:
                y = token.matches[1];
                m = token.matches[2] - 1; // Month start by index 0
                d = token.matches[3];
                h = token.matches[4];
                mm = token.matches[5];
                break;
            case 2:
                y = token.matches[1];
                m = token.matches[2] - 1; // Month start by index 0
                d = token.matches[3];
                break;
            default:
                return null;
        }
        token = lexer.nextToken();
    }
    if (h == -1)
        h = 0;
    if (mm == -1)
        mm = 0;
    if (s == -1)
        s = 0;
    var date = new Date(y, m, d, h, mm, s);
    return date;
}
function MCDateToUTC(date) {
    var dif = date.getTimezoneOffset();
    var d = new Date();
    d.setTime(date.getTime() + (dif * 60 * 1000));
    return d;
}
function MCDateAddDaysToDateString(dateString, days) {
    var d = NSDateFromString(dateString);
    d.setDate(d.getDate() + days);
    var ds = MCDateGetDateString(d);
    return ds;
}
function MCDateRemoveDaysToDateString(dateString, days) {
    var d = NSDateFromString(dateString);
    d.setDate(d.getDate() - days);
    var ds = MCDateGetDateString(d);
    return ds;
}
function MCDateFromMiliseconds(miliseconds) {
    var epoch = miliseconds;
    if (epoch < 10000000000)
        epoch *= 1000; // convert to milliseconds (Epoch is usually expressed in seconds, but Javascript uses Milliseconds)
    var ds = new Date();
    ds.setTime(epoch);
    return ds;
}
function isDate(x) {
    return (null != x) && !isNaN(x) && ("undefined" !== typeof x.getDate);
}
function MCDateToday() {
    var d = new Date();
    d.setHours(0, 0, 0);
    return d;
}
function MCDateNow() {
    return new Date();
}
function MCDateTodayString() {
    var d = MCDateToday();
    return MCDateGetString(d);
}
function MCDateYesterday() {
    var d = new Date();
    d.setDate(d.getDate() - 1);
    d.setHours(0, 0, 0);
    return d;
}
function MCDateTomorrow() {
    var d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0);
    return d;
}
function MCDateGetFirstDayOfTheWeek(date) {
    var dayString = MCDateGetDateString(date);
    // TODO: Check sunday start or monday start
    var firstDayString = MCDateRemoveDaysToDateString(dayString, date.getDay() - 1);
    var first = NSDateFromString(firstDayString);
    return first;
}
function MCDateGetLastDayOfTheWeek(date) {
    var dayString = MCDateGetDateString(date);
    // TODO: Check sunday start or monday start
    var lastDayString = MCDateAddDaysToDateString(dayString, (7 - date.getDay()));
    var last = NSDateFromString(lastDayString);
    return last;
}
function MCDateGetFirstDateOfTheMonth(month, year) {
    return new Date(year, month, 1);
}
function MCDateGetFirstDayOfTheMonth(month, year) {
    var d = MCDateGetFirstDateOfTheMonth(month, year);
    return d.getDate();
}
function MCDateGetLastDateOfTheMonth(month, year) {
    return new Date(year, month + 1, 0);
}
function MCDateGetLastDayOfTheMonth(month, year) {
    var d = MCDateGetLastDateOfTheMonth(month, year);
    return d.getDate();
}
function MCDateCopy(date) {
    return new Date(date.getTime());
}


/***/ }),

/***/ "./sources/MIOCoreHTMLParser.ts":
/*!**************************************!*\
  !*** ./sources/MIOCoreHTMLParser.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOCoreHTMLParser: () => (/* binding */ MIOCoreHTMLParser),
/* harmony export */   MIOCoreHTMLParserTokenType: () => (/* binding */ MIOCoreHTMLParserTokenType)
/* harmony export */ });
/* harmony import */ var _MIOCoreString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./MIOCoreString */ "./sources/MIOCoreString.ts");

var MIOCoreHTMLParserTokenType;
(function (MIOCoreHTMLParserTokenType) {
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["Identifier"] = 0] = "Identifier";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["OpenTag"] = 1] = "OpenTag";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["CloseTag"] = 2] = "CloseTag";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["OpenCloseTag"] = 3] = "OpenCloseTag";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["InlineCloseTag"] = 4] = "InlineCloseTag";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["Question"] = 5] = "Question";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["Exclamation"] = 6] = "Exclamation";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["Equal"] = 7] = "Equal";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["Quote"] = 8] = "Quote";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["Commentary"] = 9] = "Commentary";
    MIOCoreHTMLParserTokenType[MIOCoreHTMLParserTokenType["End"] = 10] = "End";
})(MIOCoreHTMLParserTokenType || (MIOCoreHTMLParserTokenType = {}));
var MIOCoreHTMLParser = /** @class */ (function () {
    function MIOCoreHTMLParser() {
        this.string = null;
        this.stringIndex = 0;
        this.delegate = null;
        this.exceptionsTags = ["!DOCTYPE", "area", "base", "br", "col", "hr", "img", "input", "link", "meta", "param", "keygen", "source"];
        this.lastTokenIndex = -1;
        this.lastTokenValue = null;
    }
    MIOCoreHTMLParser.prototype.initWithString = function (string, delegate) {
        this.string = string;
        this.delegate = delegate;
    };
    MIOCoreHTMLParser.prototype.nextChar = function () {
        if (this.stringIndex >= this.string.length)
            return null;
        var ch = this.string.charAt(this.stringIndex);
        this.stringIndex++;
        return ch;
    };
    MIOCoreHTMLParser.prototype.prevChar = function () {
        this.stringIndex--;
        return this.string.charAt(this.stringIndex);
    };
    MIOCoreHTMLParser.prototype.getChars = function (stopChars) {
        var chs = "";
        var exit = false;
        while (exit == false) {
            chs += this.nextChar();
            if ((0,_MIOCoreString__WEBPACK_IMPORTED_MODULE_0__.MIOCoreStringHasSuffix)(chs, stopChars) == true)
                exit = true;
        }
        // Remove the stop chars
        return chs.substr(0, chs.length - stopChars.length);
    };
    /*
    STREAM TOKENIZER
    */
    MIOCoreHTMLParser.prototype.readToken = function () {
        var value = "";
        this.lastTokenIndex = this.stringIndex;
        var ch = this.nextChar();
        if (ch == null)
            return null;
        while (ch == " ")
            ch = this.nextChar();
        var exit = false;
        while (exit == false) {
            switch (ch) {
                case "<":
                    if (value.length == 0)
                        value = this.minor();
                    else
                        this.prevChar();
                    exit = true;
                    break;
                // case "!":
                //     if (value.length == 0) value = this.exclamation();
                //     else this.prevChar();
                //     exit = true;
                //     break;
                case ">":
                    if (value.length == 0)
                        value = this.major();
                    else
                        this.prevChar();
                    exit = true;
                    break;
                // case "/":
                //     if (value.length == 0) value = this.slash();
                //     else this.prevChar();                    
                //     exit = true;
                //     break;
                case "=":
                    if (value.length == 0)
                        value = ch;
                    else
                        this.prevChar();
                    exit = true;
                case " ":
                    exit = true;
                    break;
                case "\"":
                case "'":
                    if (value.length == 0)
                        value = ch;
                    exit = true;
                    break;
                default:
                    value += ch;
                    ch = this.nextChar();
                    if (ch == null)
                        exit = true;
                    break;
            }
        }
        return value;
    };
    MIOCoreHTMLParser.prototype.minor = function () {
        var ch = this.nextChar();
        var value = "";
        switch (ch) {
            case "/":
                value = "</";
                break;
            case "!":
                value = this.exclamation();
                break;
            default:
                value = "<";
                this.prevChar();
                break;
        }
        return value;
    };
    MIOCoreHTMLParser.prototype.major = function () {
        this.prevChar(); // Major symbol
        var ch = this.prevChar();
        var value = ">";
        if (ch == "/") {
            value = "/>";
        }
        value = this.nextChar();
        value = this.nextChar();
        return value;
    };
    // private slash(){
    //     let ch = this.nextChar();
    //     if (ch == ">") return "/>";
    //     this.unexpectedToken();
    // }
    MIOCoreHTMLParser.prototype.exclamation = function () {
        var ch = this.nextChar();
        if (ch == "-") {
            var ch2 = this.nextChar();
            if (ch2 == "-") {
                return "<!--";
            }
            else
                this.unexpectedToken(ch + ch2);
        }
        this.prevChar();
        this.prevChar();
        return "<";
    };
    MIOCoreHTMLParser.prototype.prevToken = function () {
        this.stringIndex = this.lastTokenIndex;
        this.lastTokenIndex = -1;
        var value = this.lastTokenValue;
        this.lastTokenValue = null;
        return value;
    };
    MIOCoreHTMLParser.prototype.nextToken = function () {
        var type = MIOCoreHTMLParserTokenType.Identifier;
        var value = this.readToken();
        if (value == null)
            return [MIOCoreHTMLParserTokenType.End, value];
        switch (value) {
            case "<":
                type = MIOCoreHTMLParserTokenType.OpenTag;
                break;
            case ">":
                type = MIOCoreHTMLParserTokenType.CloseTag;
                break;
            case "</":
                type = MIOCoreHTMLParserTokenType.OpenCloseTag;
                break;
            case "/>":
                type = MIOCoreHTMLParserTokenType.InlineCloseTag;
                break;
            case "<!--":
                type = MIOCoreHTMLParserTokenType.Commentary;
                break;
            case "=":
                type = MIOCoreHTMLParserTokenType.Equal;
                break;
            case "\"":
            case "'":
                type = MIOCoreHTMLParserTokenType.Quote;
                break;
        }
        this.lastTokenValue = value;
        return [type, value];
    };
    /*
        PARSER
    */
    MIOCoreHTMLParser.prototype.parse = function () {
        if (this.string == null)
            return;
        if (typeof this.delegate.parserDidStartDocument === "function") {
            this.delegate.parserDidStartDocument(this);
        }
        var exit = false;
        do {
            var _a = this.nextToken(), type = _a[0], value = _a[1];
            switch (type) {
                case MIOCoreHTMLParserTokenType.OpenTag:
                    this.openTag();
                    break;
                case MIOCoreHTMLParserTokenType.OpenCloseTag:
                    this.closeElement();
                    break;
                case MIOCoreHTMLParserTokenType.Commentary:
                    this.comment();
                    break;
                case MIOCoreHTMLParserTokenType.Identifier:
                    this.foundChars(value);
                    break;
                case MIOCoreHTMLParserTokenType.End:
                    exit = true;
                    break;
                default:
                    this.unexpectedToken(value);
                    break;
            }
        } while (exit == false);
        if (typeof this.delegate.parserDidEndDocument === "function") {
            this.delegate.parserDidEndDocument(this);
        }
    };
    MIOCoreHTMLParser.prototype.unexpectedToken = function (value) {
        throw new Error("Unexpected token: " + value);
    };
    MIOCoreHTMLParser.prototype.openTag = function () {
        var _a = this.nextToken(), type = _a[0], value = _a[1];
        switch (type) {
            case MIOCoreHTMLParserTokenType.Identifier:
                this.openElement(value);
                break;
            case MIOCoreHTMLParserTokenType.Exclamation:
                this.exclamation();
                break;
        }
    };
    MIOCoreHTMLParser.prototype.openElement = function (element) {
        var attributes = this.attributes();
        this.closeTag(element, attributes);
    };
    MIOCoreHTMLParser.prototype.attributes = function () {
        var attributes = {};
        var exit = false;
        var attrKey = null;
        var isKey = true;
        while (exit == false) {
            var _a = this.nextToken(), type = _a[0], value = _a[1];
            switch (type) {
                case MIOCoreHTMLParserTokenType.Identifier:
                    if (isKey) {
                        attrKey = value;
                        attributes[attrKey] = null;
                    }
                    else {
                        attributes[attrKey] = value;
                        isKey = true;
                    }
                    break;
                case MIOCoreHTMLParserTokenType.Equal:
                    isKey = false;
                    break;
                case MIOCoreHTMLParserTokenType.Quote:
                    attributes[attrKey] = this.getChars(value);
                    isKey = true;
                    break;
                case MIOCoreHTMLParserTokenType.CloseTag:
                case MIOCoreHTMLParserTokenType.InlineCloseTag:
                    this.prevToken();
                    exit = true;
                    break;
            }
        }
        return attributes;
    };
    MIOCoreHTMLParser.prototype.closeTag = function (element, attributes) {
        var _a = this.nextToken(), type = _a[0], value = _a[1];
        switch (type) {
            case MIOCoreHTMLParserTokenType.CloseTag:
                if (typeof this.delegate.parserDidStartElement === "function") {
                    this.delegate.parserDidStartElement(this, element, attributes);
                }
                // Only call close element for the execeptions tags            
                if ((this.exceptionsTags.indexOf(element) > -1) && (typeof this.delegate.parserDidEndElement === "function")) {
                    this.delegate.parserDidEndElement(this, element);
                }
                // Special cases like <style></style> or <script></script>
                // We need to read everything 'til the next close tag
                if (element == "style" || element == "script") {
                    var chars = this.readToNextString("</" + element + ">");
                    this.foundChars(chars);
                    if (typeof this.delegate.parserDidEndElement === "function") {
                        this.delegate.parserDidEndElement(this, element);
                    }
                }
                break;
            case MIOCoreHTMLParserTokenType.InlineCloseTag:
                if (typeof this.delegate.parserDidEndElement === "function") {
                    this.delegate.parserDidEndElement(this, element);
                }
                break;
            default:
                this.unexpectedToken(value);
                break;
        }
    };
    MIOCoreHTMLParser.prototype.closeElement = function () {
        var _a;
        var _b = this.nextToken(), type = _b[0], value = _b[1];
        if (type != MIOCoreHTMLParserTokenType.Identifier)
            this.unexpectedToken(value);
        var element = value;
        _a = this.nextToken(), type = _a[0], value = _a[1];
        if (type != MIOCoreHTMLParserTokenType.CloseTag)
            this.unexpectedToken(value);
        if (typeof this.delegate.parserDidEndElement === "function") {
            this.delegate.parserDidEndElement(this, element);
        }
    };
    MIOCoreHTMLParser.prototype.comment = function () {
        var cmt = this.getChars("-->");
        if (typeof this.delegate.parserFoundComment === "function") {
            this.delegate.parserFoundComment(this, cmt);
        }
    };
    MIOCoreHTMLParser.prototype.foundChars = function (chars) {
        if (chars == null)
            return;
        if (typeof this.delegate.parserFoundCharacters === "function") {
            this.delegate.parserFoundCharacters(this, chars);
        }
    };
    MIOCoreHTMLParser.prototype.readToNextString = function (element) {
        var str = "";
        for (var index = 0; index < element.length; index++) {
            var ch = this.nextChar();
            if (ch == null)
                throw Error("Unexpected end of string: " + str);
            str += ch;
        }
        if (str == element)
            return null;
        var exit = false;
        while (exit == false) {
            var ch = this.nextChar();
            if (ch == null)
                throw Error("Unexpected end of string: " + str);
            str += ch;
            var cmp = str.substr(-element.length);
            if (cmp == element)
                exit = true;
        }
        var chars = str.substr(0, str.length - element.length);
        console.log("*****\n" + chars + "\n*****\n");
        return chars;
    };
    return MIOCoreHTMLParser;
}());



/***/ }),

/***/ "./sources/MIOCoreLexer.ts":
/*!*********************************!*\
  !*** ./sources/MIOCoreLexer.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOCoreLexer: () => (/* binding */ MIOCoreLexer)
/* harmony export */ });
var MIOCoreLexer = /** @class */ (function () {
    function MIOCoreLexer(string) {
        this.tokenTypes = [];
        this.tokenIndex = -1;
        this.ignoreTokenTypes = [];
        this.input = string;
    }
    MIOCoreLexer.prototype.addTokenType = function (type, regex) {
        this.tokenTypes.push({ "regex": regex, "type": type });
    };
    MIOCoreLexer.prototype.ignoreTokenType = function (type) {
        this.ignoreTokenTypes.push(type);
    };
    MIOCoreLexer.prototype.tokenize = function () {
        this.tokens = this._tokenize();
        this.tokenIndex = 0;
    };
    MIOCoreLexer.prototype._tokenize = function () {
        var tokens = [];
        var foundToken = false;
        var matches;
        var i;
        var numTokenTypes = this.tokenTypes.length;
        do {
            foundToken = false;
            for (i = 0; i < numTokenTypes; i++) {
                var regex = this.tokenTypes[i].regex;
                var type = this.tokenTypes[i].type;
                matches = regex.exec(this.input);
                if (matches) {
                    if (this.ignoreTokenTypes.indexOf(type) == -1) {
                        tokens.push({ type: type, value: matches[0], matches: matches });
                    }
                    this.input = this.input.substring(matches[0].length);
                    foundToken = true;
                    break;
                }
            }
            if (foundToken == false) {
                throw new Error("MIOCoreLexer: Token doesn't match any pattern. (".concat(this.input, ")"));
            }
        } while (this.input.length > 0);
        return tokens;
    };
    MIOCoreLexer.prototype.nextToken = function () {
        if (this.tokenIndex >= this.tokens.length) {
            return null;
        }
        var token = this.tokens[this.tokenIndex];
        this.tokenIndex++;
        // Check if we have to ignore
        var index = this.ignoreTokenTypes.indexOf(token.type);
        return index == -1 ? token : this.nextToken();
    };
    MIOCoreLexer.prototype.prevToken = function () {
        this.tokenIndex--;
        if (this.tokenIndex < 0) {
            return null;
        }
        var token = this.tokens[this.tokenIndex];
        // Check if we have to ignore
        var index = this.ignoreTokenTypes.indexOf(token.type);
        return index == -1 ? token : this.prevToken();
    };
    return MIOCoreLexer;
}());



/***/ }),

/***/ "./sources/MIOCoreString.ts":
/*!**********************************!*\
  !*** ./sources/MIOCoreString.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOCoreStringAppendPathComponent: () => (/* binding */ MIOCoreStringAppendPathComponent),
/* harmony export */   MIOCoreStringDeletingLastPathComponent: () => (/* binding */ MIOCoreStringDeletingLastPathComponent),
/* harmony export */   MIOCoreStringHasPreffix: () => (/* binding */ MIOCoreStringHasPreffix),
/* harmony export */   MIOCoreStringHasSuffix: () => (/* binding */ MIOCoreStringHasSuffix),
/* harmony export */   MIOCoreStringLastPathComponent: () => (/* binding */ MIOCoreStringLastPathComponent),
/* harmony export */   MIOCoreStringPathExtension: () => (/* binding */ MIOCoreStringPathExtension),
/* harmony export */   MIOCoreStringStandardizingPath: () => (/* binding */ MIOCoreStringStandardizingPath),
/* harmony export */   MIOLocalizeString: () => (/* binding */ MIOLocalizeString),
/* harmony export */   MIOLocalizedStringsGet: () => (/* binding */ MIOLocalizedStringsGet),
/* harmony export */   MIOLocalizedStringsSet: () => (/* binding */ MIOLocalizedStringsSet),
/* harmony export */   MIOStringWithFormat: () => (/* binding */ MIOStringWithFormat)
/* harmony export */ });
function MIOCoreStringHasPreffix(str, preffix) {
    return str.substring(0, preffix.length) === preffix;
}
function MIOCoreStringHasSuffix(str, suffix) {
    var s = str.substr(str.length - suffix.length);
    return s == suffix;
}
function MIOCoreStringAppendPathComponent(string, path) {
    var str = string;
    if (string.charAt(string.length - 1) == "/" && path.charAt(0) == "/") {
        str += path.substr(1);
    }
    else if (string.charAt(string.length - 1) != "/" && path.charAt(0) != "/") {
        str += "/" + path;
    }
    else {
        str += path;
    }
    return str;
}
function MIOCoreStringLastPathComponent(string) {
    var index = string.lastIndexOf("/");
    if (index == -1)
        return string;
    var len = string.length - index;
    var str = string.substr(index, len);
    return str;
}
function MIOCoreStringPathExtension(string) {
    var lastPathComponent = MIOCoreStringLastPathComponent(string);
    var items = lastPathComponent.split(".");
    if (items.length == 1)
        return "";
    var ext = items[items.length - 1];
    return ext;
}
function MIOCoreStringDeletingLastPathComponent(string) {
    var index = string.lastIndexOf("/");
    var str = string.substr(0, index);
    return str;
}
function MIOCoreStringStandardizingPath(string) {
    var array = string.split("/");
    var newArray = [];
    var index = 0;
    for (var count = 0; count < array.length; count++) {
        var component = array[count];
        if (component.substr(0, 2) == "..")
            index--;
        else {
            newArray[index] = component;
            index++;
        }
    }
    var str = "";
    if (index > 0)
        str = newArray[0];
    for (var count = 1; count < index; count++) {
        str += "/" + newArray[count];
    }
    return str;
}
var _MIOLocalizedStrings = null;
function MIOLocalizeString(key, comments) {
    var strings = _MIOLocalizedStrings;
    if (strings == null)
        return key;
    var value = strings[key];
    if (value == null)
        return key;
    return value;
}
function MIOLocalizedStringsSet(data) {
    _MIOLocalizedStrings = data;
}
function MIOLocalizedStringsGet() {
    return _MIOLocalizedStrings;
}
function MIOStringWithFormat(format) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (args.length == 0)
        return format;
    var index = 0;
    var str = format.replace(/(%s|%i)/g, function (match) {
        var result = typeof args[index] != "undefined" ? args[index] : match;
        index++;
        return result;
    });
    return str;
}


/***/ }),

/***/ "./sources/MIOCoreUUID.ts":
/*!********************************!*\
  !*** ./sources/MIOCoreUUID.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOCoreUUIDcreate: () => (/* binding */ MIOCoreUUIDcreate)
/* harmony export */ });
function MIOCoreUUIDcreate() {
    var d = new Date().getTime();
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid.toUpperCase();
}


/***/ }),

/***/ "./sources/MIOCrypto.ts":
/*!******************************!*\
  !*** ./sources/MIOCrypto.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOCoreCreateMD5: () => (/* binding */ MIOCoreCreateMD5)
/* harmony export */ });
// MD5 implementacion
function MIOCoreCreateMD5(s) { function L(k, d) { return (k << d) | (k >>> (32 - d)); } function K(G, k) { var I, d, F, H, x; F = (G & 2147483648); H = (k & 2147483648); I = (G & 1073741824); d = (k & 1073741824); x = (G & 1073741823) + (k & 1073741823); if (I & d) {
    return (x ^ 2147483648 ^ F ^ H);
} if (I | d) {
    if (x & 1073741824) {
        return (x ^ 3221225472 ^ F ^ H);
    }
    else {
        return (x ^ 1073741824 ^ F ^ H);
    }
}
else {
    return (x ^ F ^ H);
} } function r(d, F, k) { return (d & F) | ((~d) & k); } function q(d, F, k) { return (d & k) | (F & (~k)); } function p(d, F, k) { return (d ^ F ^ k); } function n(d, F, k) { return (F ^ (d | (~k))); } function u(G, F, aa, Z, k, H, I) { G = K(G, K(K(r(F, aa, Z), k), I)); return K(L(G, H), F); } function f(G, F, aa, Z, k, H, I) { G = K(G, K(K(q(F, aa, Z), k), I)); return K(L(G, H), F); } function D(G, F, aa, Z, k, H, I) { G = K(G, K(K(p(F, aa, Z), k), I)); return K(L(G, H), F); } function t(G, F, aa, Z, k, H, I) { G = K(G, K(K(n(F, aa, Z), k), I)); return K(L(G, H), F); } function e(G) { var Z; var F = G.length; var x = F + 8; var k = (x - (x % 64)) / 64; var I = (k + 1) * 16; var aa = Array(I - 1); var d = 0; var H = 0; while (H < F) {
    Z = (H - (H % 4)) / 4;
    d = (H % 4) * 8;
    aa[Z] = (aa[Z] | (G.charCodeAt(H) << d));
    H++;
} Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = aa[Z] | (128 << d); aa[I - 2] = F << 3; aa[I - 1] = F >>> 29; return aa; } function B(x) { var k = "", F = "", G, d; for (d = 0; d <= 3; d++) {
    G = (x >>> (d * 8)) & 255;
    F = "0" + G.toString(16);
    k = k + F.substr(F.length - 2, 2);
} return k; } function J(k) { k = k.replace(/rn/g, "n"); var d = ""; for (var F = 0; F < k.length; F++) {
    var x = k.charCodeAt(F);
    if (x < 128) {
        d += String.fromCharCode(x);
    }
    else {
        if ((x > 127) && (x < 2048)) {
            d += String.fromCharCode((x >> 6) | 192);
            d += String.fromCharCode((x & 63) | 128);
        }
        else {
            d += String.fromCharCode((x >> 12) | 224);
            d += String.fromCharCode(((x >> 6) & 63) | 128);
            d += String.fromCharCode((x & 63) | 128);
        }
    }
} return d; } var C = Array(); var P, h, E, v, g, Y, X, W, V; var S = 7, Q = 12, N = 17, M = 22; var A = 5, z = 9, y = 14, w = 20; var o = 4, m = 11, l = 16, j = 23; var U = 6, T = 10, R = 15, O = 21; s = J(s); C = e(s); Y = 1732584193; X = 4023233417; W = 2562383102; V = 271733878; for (P = 0; P < C.length; P += 16) {
    h = Y;
    E = X;
    v = W;
    g = V;
    Y = u(Y, X, W, V, C[P + 0], S, 3614090360);
    V = u(V, Y, X, W, C[P + 1], Q, 3905402710);
    W = u(W, V, Y, X, C[P + 2], N, 606105819);
    X = u(X, W, V, Y, C[P + 3], M, 3250441966);
    Y = u(Y, X, W, V, C[P + 4], S, 4118548399);
    V = u(V, Y, X, W, C[P + 5], Q, 1200080426);
    W = u(W, V, Y, X, C[P + 6], N, 2821735955);
    X = u(X, W, V, Y, C[P + 7], M, 4249261313);
    Y = u(Y, X, W, V, C[P + 8], S, 1770035416);
    V = u(V, Y, X, W, C[P + 9], Q, 2336552879);
    W = u(W, V, Y, X, C[P + 10], N, 4294925233);
    X = u(X, W, V, Y, C[P + 11], M, 2304563134);
    Y = u(Y, X, W, V, C[P + 12], S, 1804603682);
    V = u(V, Y, X, W, C[P + 13], Q, 4254626195);
    W = u(W, V, Y, X, C[P + 14], N, 2792965006);
    X = u(X, W, V, Y, C[P + 15], M, 1236535329);
    Y = f(Y, X, W, V, C[P + 1], A, 4129170786);
    V = f(V, Y, X, W, C[P + 6], z, 3225465664);
    W = f(W, V, Y, X, C[P + 11], y, 643717713);
    X = f(X, W, V, Y, C[P + 0], w, 3921069994);
    Y = f(Y, X, W, V, C[P + 5], A, 3593408605);
    V = f(V, Y, X, W, C[P + 10], z, 38016083);
    W = f(W, V, Y, X, C[P + 15], y, 3634488961);
    X = f(X, W, V, Y, C[P + 4], w, 3889429448);
    Y = f(Y, X, W, V, C[P + 9], A, 568446438);
    V = f(V, Y, X, W, C[P + 14], z, 3275163606);
    W = f(W, V, Y, X, C[P + 3], y, 4107603335);
    X = f(X, W, V, Y, C[P + 8], w, 1163531501);
    Y = f(Y, X, W, V, C[P + 13], A, 2850285829);
    V = f(V, Y, X, W, C[P + 2], z, 4243563512);
    W = f(W, V, Y, X, C[P + 7], y, 1735328473);
    X = f(X, W, V, Y, C[P + 12], w, 2368359562);
    Y = D(Y, X, W, V, C[P + 5], o, 4294588738);
    V = D(V, Y, X, W, C[P + 8], m, 2272392833);
    W = D(W, V, Y, X, C[P + 11], l, 1839030562);
    X = D(X, W, V, Y, C[P + 14], j, 4259657740);
    Y = D(Y, X, W, V, C[P + 1], o, 2763975236);
    V = D(V, Y, X, W, C[P + 4], m, 1272893353);
    W = D(W, V, Y, X, C[P + 7], l, 4139469664);
    X = D(X, W, V, Y, C[P + 10], j, 3200236656);
    Y = D(Y, X, W, V, C[P + 13], o, 681279174);
    V = D(V, Y, X, W, C[P + 0], m, 3936430074);
    W = D(W, V, Y, X, C[P + 3], l, 3572445317);
    X = D(X, W, V, Y, C[P + 6], j, 76029189);
    Y = D(Y, X, W, V, C[P + 9], o, 3654602809);
    V = D(V, Y, X, W, C[P + 12], m, 3873151461);
    W = D(W, V, Y, X, C[P + 15], l, 530742520);
    X = D(X, W, V, Y, C[P + 2], j, 3299628645);
    Y = t(Y, X, W, V, C[P + 0], U, 4096336452);
    V = t(V, Y, X, W, C[P + 7], T, 1126891415);
    W = t(W, V, Y, X, C[P + 14], R, 2878612391);
    X = t(X, W, V, Y, C[P + 5], O, 4237533241);
    Y = t(Y, X, W, V, C[P + 12], U, 1700485571);
    V = t(V, Y, X, W, C[P + 3], T, 2399980690);
    W = t(W, V, Y, X, C[P + 10], R, 4293915773);
    X = t(X, W, V, Y, C[P + 1], O, 2240044497);
    Y = t(Y, X, W, V, C[P + 8], U, 1873313359);
    V = t(V, Y, X, W, C[P + 15], T, 4264355552);
    W = t(W, V, Y, X, C[P + 6], R, 2734768916);
    X = t(X, W, V, Y, C[P + 13], O, 1309151649);
    Y = t(Y, X, W, V, C[P + 4], U, 4149444226);
    V = t(V, Y, X, W, C[P + 11], T, 3174756917);
    W = t(W, V, Y, X, C[P + 2], R, 718787259);
    X = t(X, W, V, Y, C[P + 9], O, 3951481745);
    Y = K(Y, h);
    X = K(X, E);
    W = K(W, v);
    V = K(V, g);
} var i = B(Y) + B(X) + B(W) + B(V); return i.toLowerCase(); }
;


/***/ }),

/***/ "./sources/MIOURL.ts":
/*!***************************!*\
  !*** ./sources/MIOURL.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOHTTPRequest: () => (/* binding */ MIOHTTPRequest)
/* harmony export */ });
function MIOHTTPRequest(instance, urlString, headers, method, body, binary, delegate, target, completion, download, fileName) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        if (this.status >= 200 && this.status <= 300) {
            // success!
            if (delegate != null)
                delegate.connectionDidReceiveText(instance, this.responseText);
            else if (binary == false || download == false) {
                completion.call(target, this.status, this.responseText);
            }
            else if (target != null) {
                var type_response = xhr.getResponseHeader('Content-Type');
                var type = type_response != null ? type_response.split(';')[0] : null;
                if (type != null && type != 'application/json' && type != 'text/html') {
                    //xhr.overrideMimeType('text/plain; charset=x-user-defined');
                    var filename = fileName;
                    // if (fileName == null) {
                    //     let disposition = xhr.getResponseHeader('Content-Disposition');
                    //     if (disposition && disposition.indexOf('attachment') !== -1) {
                    //         let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    //         let matches = filenameRegex.exec(disposition);
                    //         if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                    //     }    
                    // }
                    if (fileName == null) {
                        switch (type) {
                            case "application/pdf":
                                filename = 'document.pdf';
                                break;
                            case "application/csv":
                                filename = 'document.csv';
                                break;
                            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                                filename = 'document.xlsx';
                                break;
                            case "application/vnd.ms-excel":
                                filename = 'document.xls';
                                break;
                            default:
                                filename = "document";
                                break;
                        }
                    }
                    var data = new Uint8Array(this.response);
                    if (download == true) {
                        var blob = new Blob([data], { type: type });
                        if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                            window.navigator.msSaveBlob(blob, filename);
                        }
                        else {
                            var URL_1 = window.URL || window.webkitURL;
                            var downloadUrl_1 = URL_1.createObjectURL(blob);
                            if (filename) {
                                // use HTML5 a[download] attribute to specify filename
                                var a = document.createElement("a");
                                // safari doesn't support this yet
                                if (typeof a.download === 'undefined') {
                                    window.location.href = downloadUrl_1; // TODO: maybe location.href
                                }
                                else {
                                    a.href = downloadUrl_1;
                                    a.download = filename;
                                    document.body.appendChild(a);
                                    a.click();
                                }
                            }
                            else {
                                window.location.href = downloadUrl_1; // TODO: maybe location.href
                            }
                            setTimeout(function () { URL_1.revokeObjectURL(downloadUrl_1); }, 100); // cleanup
                            completion.call(target, this.status, null, null);
                        }
                        /// #endif
                    }
                    else {
                        var arr = new Array();
                        for (var i = 0; i != data.length; ++i)
                            arr[i] = String.fromCharCode(data[i]);
                        var bstr = arr.join("");
                        completion.call(target, this.status, null, bstr);
                    }
                }
                else {
                    var res = this.responseType != 'arraybuffer' ? this.responseText : "ERROR";
                    completion.call(target, this.status, res);
                }
            }
        }
        else {
            // something went wrong
            if (delegate != null)
                delegate.connectionDidFail(instance);
            else if (target != null)
                completion.call(target, this.status, this.responseText);
        }
    };
    xhr.onerror = function (error) {
        // something went wrong
        if (delegate != null)
            delegate.connectionDidFail(instance);
        else if (target != null)
            completion.call(target, this.status, this.responseText);
    };
    xhr.open(method, urlString);
    // Add headers
    for (var count = 0; count < headers.length; count++) {
        var item = headers[count];
        xhr.setRequestHeader(item["Field"], item["Value"]);
    }
    if (binary == true)
        xhr.responseType = "arraybuffer";
    if (method == "GET" || body == null)
        xhr.send();
    else
        xhr.send(body);
}
function MIOCoreLoadFileFromURL(url, callback) {
    var instance = this;
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        if (this.status == 200 && this.responseText != null) {
            // Success!
            callback(this.status, this.responseText);
        }
        else {
            // something went wrong
            console.log("MIOCoreLoadURL: Error downloading resource at " + url + " (Code: " + this.status + ")");
            callback(this.status, null);
        }
    };
    console.log("MIOCoreLoadURL: Downloading resource at " + url);
    xhr.open("GET", url);
    xhr.send();
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./sources/_index.ts ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MCDateAddDaysToDateString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateAddDaysToDateString),
/* harmony export */   MCDateCopy: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateCopy),
/* harmony export */   MCDateFromMiliseconds: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateFromMiliseconds),
/* harmony export */   MCDateGetDateString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetDateString),
/* harmony export */   MCDateGetDayFromDate: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetDayFromDate),
/* harmony export */   MCDateGetDayStringFromDate: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetDayStringFromDate),
/* harmony export */   MCDateGetFirstDateOfTheMonth: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetFirstDateOfTheMonth),
/* harmony export */   MCDateGetFirstDayOfTheMonth: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetFirstDayOfTheMonth),
/* harmony export */   MCDateGetFirstDayOfTheWeek: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetFirstDayOfTheWeek),
/* harmony export */   MCDateGetLastDateOfTheMonth: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetLastDateOfTheMonth),
/* harmony export */   MCDateGetLastDayOfTheMonth: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetLastDayOfTheMonth),
/* harmony export */   MCDateGetLastDayOfTheWeek: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetLastDayOfTheWeek),
/* harmony export */   MCDateGetMonthFromDate: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetMonthFromDate),
/* harmony export */   MCDateGetString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetString),
/* harmony export */   MCDateGetStringForDay: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetStringForDay),
/* harmony export */   MCDateGetStringForMonth: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetStringForMonth),
/* harmony export */   MCDateGetTimeString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetTimeString),
/* harmony export */   MCDateGetUTCDateString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetUTCDateString),
/* harmony export */   MCDateGetUTCString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetUTCString),
/* harmony export */   MCDateGetUTCTimeString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetUTCTimeString),
/* harmony export */   MCDateGetYearFromDate: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateGetYearFromDate),
/* harmony export */   MCDateNow: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateNow),
/* harmony export */   MCDateRemoveDaysToDateString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateRemoveDaysToDateString),
/* harmony export */   MCDateSetFirstWeekDay: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateSetFirstWeekDay),
/* harmony export */   MCDateToUTC: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateToUTC),
/* harmony export */   MCDateToday: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateToday),
/* harmony export */   MCDateTodayString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateTodayString),
/* harmony export */   MCDateTomorrow: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateTomorrow),
/* harmony export */   MCDateYesterday: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.MCDateYesterday),
/* harmony export */   MIOCoreAddLanguage: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreAddLanguage),
/* harmony export */   MIOCoreArrayClone: () => (/* reexport safe */ _MIOCoreClone__WEBPACK_IMPORTED_MODULE_1__.MIOCoreArrayClone),
/* harmony export */   MIOCoreClassByName: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreClassByName),
/* harmony export */   MIOCoreCreateMD5: () => (/* reexport safe */ _MIOCrypto__WEBPACK_IMPORTED_MODULE_6__.MIOCoreCreateMD5),
/* harmony export */   MIOCoreGetContentsFromURLString: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetContentsFromURLString),
/* harmony export */   MIOCoreGetDeviceUUID: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetDeviceUUID),
/* harmony export */   MIOCoreGetLanguages: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetLanguages),
/* harmony export */   MIOCoreGetMainURLString: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetMainURLString),
/* harmony export */   MIOCoreGetPlatform: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetPlatform),
/* harmony export */   MIOCoreGetPlatformLanguage: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetPlatformLanguage),
/* harmony export */   MIOCoreGetQueryOptions: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetQueryOptions),
/* harmony export */   MIOCoreHTMLParser: () => (/* reexport safe */ _MIOCoreHTMLParser__WEBPACK_IMPORTED_MODULE_2__.MIOCoreHTMLParser),
/* harmony export */   MIOCoreHTMLParserTokenType: () => (/* reexport safe */ _MIOCoreHTMLParser__WEBPACK_IMPORTED_MODULE_2__.MIOCoreHTMLParserTokenType),
/* harmony export */   MIOCoreIsDesktop: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreIsDesktop),
/* harmony export */   MIOCoreIsMobile: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreIsMobile),
/* harmony export */   MIOCoreIsPad: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreIsPad),
/* harmony export */   MIOCoreIsPhone: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreIsPhone),
/* harmony export */   MIOCoreLexer: () => (/* reexport safe */ _MIOCoreLexer__WEBPACK_IMPORTED_MODULE_3__.MIOCoreLexer),
/* harmony export */   MIOCoreObjectClone: () => (/* reexport safe */ _MIOCoreClone__WEBPACK_IMPORTED_MODULE_1__.MIOCoreObjectClone),
/* harmony export */   MIOCorePlatformType: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCorePlatformType),
/* harmony export */   MIOCoreRegisterClassByName: () => (/* reexport safe */ _MIOCore__WEBPACK_IMPORTED_MODULE_0__.MIOCoreRegisterClassByName),
/* harmony export */   MIOCoreStringAppendPathComponent: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOCoreStringAppendPathComponent),
/* harmony export */   MIOCoreStringDeletingLastPathComponent: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOCoreStringDeletingLastPathComponent),
/* harmony export */   MIOCoreStringHasPreffix: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOCoreStringHasPreffix),
/* harmony export */   MIOCoreStringHasSuffix: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOCoreStringHasSuffix),
/* harmony export */   MIOCoreStringLastPathComponent: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOCoreStringLastPathComponent),
/* harmony export */   MIOCoreStringPathExtension: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOCoreStringPathExtension),
/* harmony export */   MIOCoreStringStandardizingPath: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOCoreStringStandardizingPath),
/* harmony export */   MIOCoreUUIDcreate: () => (/* reexport safe */ _MIOCoreUUID__WEBPACK_IMPORTED_MODULE_5__.MIOCoreUUIDcreate),
/* harmony export */   MIOHTTPRequest: () => (/* reexport safe */ _MIOURL__WEBPACK_IMPORTED_MODULE_7__.MIOHTTPRequest),
/* harmony export */   MIOLocalizeString: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOLocalizeString),
/* harmony export */   MIOLocalizedStringsGet: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOLocalizedStringsGet),
/* harmony export */   MIOLocalizedStringsSet: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOLocalizedStringsSet),
/* harmony export */   MIOStringWithFormat: () => (/* reexport safe */ _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__.MIOStringWithFormat),
/* harmony export */   NSDateFromString: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.NSDateFromString),
/* harmony export */   isDate: () => (/* reexport safe */ _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__.isDate)
/* harmony export */ });
/* harmony import */ var _MIOCore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./MIOCore */ "./sources/MIOCore.ts");
/* harmony import */ var _MIOCoreClone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./MIOCoreClone */ "./sources/MIOCoreClone.ts");
/* harmony import */ var _MIOCoreHTMLParser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./MIOCoreHTMLParser */ "./sources/MIOCoreHTMLParser.ts");
/* harmony import */ var _MIOCoreLexer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./MIOCoreLexer */ "./sources/MIOCoreLexer.ts");
/* harmony import */ var _MIOCoreString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./MIOCoreString */ "./sources/MIOCoreString.ts");
/* harmony import */ var _MIOCoreUUID__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./MIOCoreUUID */ "./sources/MIOCoreUUID.ts");
/* harmony import */ var _MIOCrypto__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./MIOCrypto */ "./sources/MIOCrypto.ts");
/* harmony import */ var _MIOURL__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./MIOURL */ "./sources/MIOURL.ts");
/* harmony import */ var _MIOCoreDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./MIOCoreDate */ "./sources/MIOCoreDate.ts");










})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=mio-core.js.map